import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0273304"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-xxl"
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-wrap flex-stack my-5"
}
const _hoisted_4 = { class: "fs-2 fw-bold my-2" }
const _hoisted_5 = { class: "d-flex flex-wrap my-1 gap-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-filter me-2",
  style: {"color":"#FFFFFF"}
}, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "badge badge-light-success ms-2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg me-2" }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_10 = {
  key: 2,
  class: "row g-6 g-xl-9"
}
const _hoisted_11 = {
  key: 3,
  class: "d-flex flex-wrap flex-stack my-5 mt-10"
}
const _hoisted_12 = { class: "fs-2 fw-bold my-2" }
const _hoisted_13 = {
  key: 4,
  class: "row g-6 g-xl-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_course_card = _resolveComponent("course-card")!
  const _component_course_filter_modal = _resolveComponent("course-filter-modal")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.courses.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.all_courses_available`)), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openFilterModal && _ctx.openFilterModal(...args))),
                  class: _normalizeClass(["btn btn-sm d-flex align-items-center", _ctx.hasActiveFilters ? 'btn-primary' : '']),
                  style: {"background":"#323248"}
                }, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.filter`)) + " ", 1),
                  (_ctx.hasActiveFilters)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "●"))
                    : _createCommentVNode("", true)
                ], 2),
                (_ctx.hasActiveFilters)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args))),
                      class: "btn btn-sm btn-light-danger d-flex align-items-center"
                    }, [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.clear_filters`)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.loading_all_courses`)) + "... ", 1)),
        (_ctx.courses.data && _ctx.coursesWithCertificate.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursesWithCertificate, (course) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4",
                  key: course.id
                }, [
                  _createVNode(_component_course_card, {
                    course: course,
                    "current-language": _ctx.currentLanguage
                  }, null, 8, ["course", "current-language"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.courses.data && _ctx.coursesWithoutCertificate.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.page_dashboard.other_content`)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.courses.data && _ctx.coursesWithoutCertificate.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursesWithoutCertificate, (course) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4",
                  key: course.id
                }, [
                  _createVNode(_component_course_card, {
                    course: course,
                    "current-language": _ctx.currentLanguage
                  }, null, 8, ["course", "current-language"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_course_filter_modal, {
      "is-open": _ctx.isFilterModalOpen,
      onClose: _ctx.closeFilterModal,
      onApply: _ctx.applyFilter
    }, null, 8, ["is-open", "onClose", "onApply"]),
    _createVNode(_component_router_view)
  ], 64))
}